<form class="kLoginForm" [formGroup]="_resendLinkForm" (submit)="_resetPassword($event)">
  <h1>{{ 'app.login.invalidLoginHash.title' | translate }}</h1>

  <ng-container *ngIf="_displayEmailField">
    <p [innerHTML]="'app.login.invalidLoginHash.instructions' | translate"></p>

    <div>
      <input
        pInputText
        autocomplete="off"
        [placeholder]="'app.login.invalidLoginHash.placeholder' | translate"
        [formControl]="_emailField"
        [ngClass]="{
          'has-error': errorMessage || _emailValidationMessage,
          'has-success': _emailField.valid && _emailField.touched
        }"
        [kTooltip]="_emailValidationMessage | translate"
        placement="right"
      />
    </div>

    <p *ngIf="errorMessage" class="kErrorMessage" [innerHTML]="errorMessage"></p>

    <div>
      <button class="kButtonDefault" pButton [label]="_resendBtnText | translate" [disabled]="inProgress"></button>
    </div>
  </ng-container>
  <ng-container *ngIf="!_displayEmailField">
    <p>{{ 'app.login.invalidLoginHash.sent.instructions' | translate: _translateParam }}</p>
  </ng-container>
</form>
